@if (targetUrl !== null) {
  <div
    class="new-version-notice d-flex align-items-center justify-content-center p-3"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="newVersionTitle"
    aria-describedby="newVersionBody">
    <div class="card shadow">
      <div class="card-body p-4">
        <h4 id="newVersionTitle" class="card-title d-flex align-items-center">
          <span class="material-icons me-2">update</span>Sidan har uppdaterats
        </h4>
        <div id="newVersionBody">
          <p>
            Klubbavgift har fått en uppdatering medan du hade sidan öppen. För att allt ska fungera som det ska behöver sidan
            laddas om – det tar bara ett ögonblick.
          </p>
          <p>Du har inte gjort något fel, och det du redan har sparat eller betalat finns kvar.</p>
        </div>
        <button #reloadButton type="button" class="btn btn-primary w-100 mt-2" (click)="reload()">Ladda om sidan</button>
      </div>
    </div>
  </div>
}
